import type { Level } from "./types";

/**
 * Matching the proven optimum is judged with a small absolute slack (in map
 * units, ≈ 1/1000 league): a genuinely different tour on these maps is always
 * several whole units longer, while an optimal tour re-summed in a different
 * leg order can drift by floating-point dust.
 */
export const OPT_EPS = 0.01;

/**
 * Stars for a voyage given the best completed round's length (map units):
 *   3 — matched the proven shortest round
 *   2 — within 5% of it
 *   1 — completed a round at all
 *   0 — no completed round yet (length 0 = never completed)
 */
export function starsFor(level: Level, bestLength: number): number {
  if (bestLength <= 0) return 0;
  if (bestLength <= level.opt + OPT_EPS) return 3;
  if (bestLength <= level.opt * 1.05) return 2;
  return 1;
}
